import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem("cartItems");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Calculate total method
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      // Calculate main item price * quantity
      const itemTotal = item.price * item.quantity;

      // Calculate extras total if they exist
      const extrasTotal = item.extras
        ? item.extras.reduce((sum, extra) => sum + extra.price, 0)
        : 0;

      return total + itemTotal + extrasTotal;
    }, 0);
  };

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const removeFromCart = (itemId, extraId = null) => {
    setCartItems((prevItems) =>
      prevItems
        .map((item) => {
          if (item.id === itemId) {
            if (extraId) {
              return {
                ...item,
                extras: item.extras.filter((extra) => extra.id !== extraId),
              };
            }
            return null;
          }
          return item;
        })
        .filter(Boolean)
    );
  };

  const updateCartItemQuantity = (itemId, newQuantity) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === itemId ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  // Add isCheckout to context value
  const [isCheckout, setIsCheckout] = useState(false);

  const clearCart = () => {
    // console.log("Clearing cart..."); // Debugging step
    setCartItems([]); // Clear the cart
    localStorage.removeItem("cartItems"); // Remove from local storage
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        setCartItems,
        removeFromCart,
        updateCartItemQuantity,
        total: calculateTotal(),
        isCheckout,
        setIsCheckout,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
